module.exports = __webpack_public_path__ + "guest-icon.png?b09008a0387953fdbc3ddd3fe2714f31";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/guest-icon.png
// module id = 441
// module chunks = 0